import react from "react";
import { TouchableOpacity } from "react-native";
import { getFaceIdSuportIos } from "../helpers/DeviceUtils";
import { IS_IOS } from "../services/Config";
import FaceID from '../components/FaceId'
import Icon from 'react-native-vector-icons/MaterialCommunityIcons'

export function AuthenticationIcon({ onPress, style }) {

    const IconAuth = () => {
        if(IS_IOS && getFaceIdSuportIos()){
            return <FaceID />
        } else {
            return <Icon name={'fingerprint'} size={32}/>
        }
    }
    
    return <TouchableOpacity style={style} onPress={onPress}>
        <IconAuth/>
    </TouchableOpacity>
}